<template>
  <v-content>
        <div class="wedrive-bg-header-container fixNotchMarginTop fixNotchPaddingBottom"></div>
        <v-row v-if="isLoading" cols="12" justify="center">
            <v-col class="mx-auto" cols="12">
                <v-skeleton-loader type="table-tbody" class="mx-auto" max-width="90%"/>
            </v-col>
        </v-row>

        <v-row justify="center" class="wedrive-cards-report-container fixNotchPaddingTop" style="overflow-x: hidden;">
            <v-col cols="12">
                <v-card v-if="!isLoading" class="mb-4 card-wedrives-report" min-width="300">
                    <v-card-text style="padding-bottom: 0;">
                        <v-row>
                            <v-col cols="12" style="padding: 0 12px;">
                               <h3 style="color: #000; display: inline;">{{ $t('report.temperatures') }}</h3>
                            </v-col>
                            <v-row cols="12" style="margin: 0; padding: 5px 0 5px 0; color: #989898; text-align: center;">
                                <v-col col="6" style="padding-bottom: 0; padding-right: 0; width: 50%;">
                                    <v-select ref="sensorSelect" outlined
                                      multiple
                                      class="search-1"
                                      v-model="sensorIds"
                                      :items="sensors"
                                      :disabled="isLoading"
                                      :label="$t('report.select-sensors')"
                                      @input="updateView('sensor')">
                                        <template v-slot:selection="{ index }">
                                            <span v-if="index == 0">{{ getSensorInput() }}</span>
                                        </template>
                                    </v-select>
                                </v-col>
                                <v-col col="6" style="padding-bottom: 0; width: 50%;">
                                    <v-select ref="rangeSelect" outlined
                                      class="search-2"
                                      v-model="rangeId"
                                      :items="ranges"
                                      :disabled="isLoading"
                                      :label="$t('report.select-dates')"
                                      @input="updateView('dates')"/>
                                </v-col>
                            </v-row>
                            <v-row cols="12" style="margin: 0; padding: 5px 0 5px 0; color: #989898; text-align: center;">
                                <v-col col="12" style="padding-top: 0; padding-bottom: 0;">
                                    <v-select outlined
                                      class="search-1"
                                      v-model="refreshRate"
                                      :items="refreshRates"
                                      :disabled="isLoading"
                                      :label="$t('print.select-refresh-rate')"
                                      @input="updateView('period')">
                                    </v-select>
                                </v-col>
                            </v-row>
                            <v-row id="title" style="width: 100%;">
                               <v-col cols="12" style="left: 12px; margin: 0; padding: 22px 24px 0;">
                                 <span id="ticketLegend" v-html="chartTitle" style="padding: 5px; font-size: 12px; font-weight: bold; color: #000; background-color: #ececec; text-align: center; display: block;"></span>
                               </v-col>
                            </v-row>
                            <v-row v-if="!showNoDataNotice" style="padding: 0 12px; max-height: 285px;">                        
                               <v-col cols="12" style="position: relative; left: -20px; top: -40px; padding: 0;">
                                 <GChart id="ticketGCHart" type="LineChart" :data="chartData" :options="chartOptions"/>
                               </v-col>
                            </v-row>
                            <v-row v-if="showNoDataNotice" style="margin-top: 20px; margin-bottom: 0; padding: 0 12px;">
                               <v-col cols="12">
                                 <v-alert type="error">
                                   {{ $t('report.no-data') }}
                                 </v-alert>
                               </v-col>
                            </v-row>
                            <!-- Legend Container -->
                            <div id="legend" class="wedrive-legend-container" style="margin: 5px 0 10px 0; height: 25px;">
                                <div v-if="showSensor1" class="wedrive-legend-content">
                                    <div class="legend-sensor-1"></div><span>{{ $t('report.sensor-1') }}</span>
                                </div>
                                <div v-if="showSensor2" class="wedrive-legend-content">
                                    <div class="legend-sensor-2"></div><span>{{ $t('report.sensor-2') }}</span>
                                </div>
                                <div v-if="showSensor3" class="wedrive-legend-content">
                                    <div class="legend-sensor-3"></div><span>{{ $t('report.sensor-3') }}</span>
                                </div>
                                <div v-if="showSensor4" class="wedrive-legend-content">
                                    <div class="legend-sensor-4"></div><span>{{ $t('report.sensor-4') }}</span>
                                </div>
                            </div>
                        </v-row>
                        
                        <v-row cols="12" style="margin: 0; padding-bottom: 0; color: #989898; text-align: center;"> 
                           <v-btn class="wedrive-vbtn primary" :disabled="isLoading || showNoDataNotice" @click="doSendEmail()">
                             {{ $t('report.send-email') }}
                           </v-btn>
                        </v-row>
                        
                        <v-row cols="12" style="margin: 0; padding-bottom: 20px; color: #989898; text-align: center;">
                            <v-btn class="wedrive-vbtn primary" :disabled="isLoading || showNoDataNotice" @click="doPrint()">
                                {{ $t('report.print') }}
                            </v-btn>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-btn dark fixed bottom right fab color="secondary" :loading="isLoading" @click="doRefresh()">
            <v-icon dark>mdi-autorenew</v-icon>
        </v-btn>
    
        <SelectDatesDialog ref='dlgSelectDates'/>
        <SendEmailDialog ref='dlgSendEmail'/>
        <PrintDialog ref='dlgPrint'/>
        <WaitDialog ref='dlgWait'/>
        <UpgradeAppDialog ref='dlgUpgradeApp'/>
        <SendEmailErrorDialog ref='dlgSendEmailError'/>
        <!-- INICIO BLOQUE MENSAJE ESTADO PETICIONES -->
        <v-snackbar
        v-model="showAlert"
        :timeout="alertTimeout"
        :color="alertColor">
						{{ alertText }}
            <v-btn text @click="showAlert=false">
            {{ $t('app.buttons.close') }}
            </v-btn>
        </v-snackbar>
        <!-- FIN BLOQUE ESTADO PETICIONES -->

    </v-content>
</template>

<script>
import DeviceUtil from "../../util/DeviceUtil";
import BaseModule from "../../common/BaseModule";
import SelectDatesDialog from './SelectDatesDialog';
import SendEmailDialog from './SendEmailDialog';
import PrintDialog from './PrintDialog';
import WaitDialog from './WaitDialog';
import UpgradeAppDialog from './UpgradeAppDialog';
import { GChart } from 'vue-google-charts';
import SendEmailErrorDialog from './SendEmailErrorDialog';
import api from "../../../api/wedrive";
import cordova from "../../../api/cordova";
import ReportUtil from "./ReportUtil";

export default {
    name: "ReportMain",
    mixins: [ BaseModule, ReportUtil, DeviceUtil ],
    components: {
      SelectDatesDialog, GChart, SendEmailDialog, PrintDialog, WaitDialog, UpgradeAppDialog, SendEmailErrorDialog
    },
    data() {
        return {
            idFleet: null,
            idMobile : null,
            aliasMobile: null,
            isLoading: false,           
            showAlert: false,
            alertColor: 'error',
            alertText: '',
            alertTimeout: 3000,
            sensorIds: [],
            rangeId: 'current-day',
						prevRangeId: null,
            showNoDataNotice: true,
            timestamp: {},
						refreshRates: [ 
							{ text: '1 ' + this.$t('print.minutes'), value: 1 },
							{ text: '5 ' + this.$t('print.minutes'), value: 5 },
							{ text: '10 ' + this.$t('print.minutes'), value: 10 },
							{ text: '15 ' + this.$t('print.minutes'), value: 15 },
							{ text: '30 ' + this.$t('print.minutes'), value: 30 },
							{ text: '60 ' + this.$t('print.minutes'), value: 60 }
						],
						refreshRate: 10,
            chartTitle: '',
            chartData: [],
            chartOptions: {
                colors: [],
                hAxis: { format: 'dd/MM/yy\r\nHH:mm' },
                vAxis: { format: '0.0ºC' },
                width: window.innerWidth + 50,
                height: 350,
                legend: { position: 'none' },
                backgroundColor: 'transparent'
            },
            ranges: [ 
                { value: 'current-day', text: this.$t('report.current-day') }, 
                { value: 'last-12h', text: this.$t('report.last-12h') }, 
                { value: 'last-24h', text: this.$t('report.last-24h') }, 
                { value: 'custom-dates', text: this.$t('report.custom-dates') } 
            ],
						showPrintFeatureNotice: false,
        };
    }, 
    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
        });
        
        window.$vue.$off('ne_backbutton');
        window.$vue.$on('ne_backbutton', this.processBackButton);
        window.$vue.$on('send-email-error', this.showSendEmailError);

        console.log('*** ReportMain - devicePlatform: ' + this.$store.state.wedrive.devicePlatform);
        
        if (this.$store.state.wedrive.devicePlatform == 'android' && this.isCordovaWrapperVersionLowerThan("1.0.13")) {
					this.showPrintFeatureNotice = true;
				} else {
					this.showPrintFeatureNotice = false;
				}
    },
    beforeDestroy() { 
        window.removeEventListener('resize', this.onResize); 
    },
    computed: {
        availableSensorIds() {
            if (this.sensorIds.length == 0) {
                return this.sensorIds;
            }

            if (this.sensorIds[0].value) {
                return this.sensorIds.map(x => x.value);
            }

            return this.sensorIds;
        },
        showSensor1() {
            return this.availableSensorIds.includes(1);
        },
        showSensor2() {
            return this.availableSensorIds.includes(2);
        },
        showSensor3() {
            return this.availableSensorIds.includes(3);
        },
        showSensor4() {
            return this.availableSensorIds.includes(4);
        },
    },
    methods: { 
        onResize: function() {
            this.chartOptions.width = window.innerWidth + 50;
        }, 
        processBackButton: function() { 
						if (this.$refs.dlgUpgradeApp.isVisible()) {
								this.$refs.dlgUpgradeApp.close();
						} else if (this.$refs.dlgPrint.isVisible()) {
                this.$refs.dlgPrint.close();
            } else if (this.$refs.dlgSendEmail.isVisible()) {
                this.$refs.dlgSendEmail.close();
            } else if (this.$refs.dlgSelectDates.isVisible()) {
                this.$refs.dlgSelectDates.close();
            } else {
                window.$vue.$off('ne_backbutton');
                this.$router.go(-1);
            }            
        },
        doShowAlert: function(payload) {
            this.alertText = payload.text;
            this.alertColor = payload.color;
            this.alertTimeout = payload.timeout;
            this.showAlert = true;
        },
        getSensorInput() {
            var text = '';

            if (this.availableSensorIds.length == this.sensors.length) {
                text = this.$t('report.all-sensors');
                return text;
            }

            if (this.availableSensorIds.length == 1) {
                text = this.$t('report.sensor', { sensor: this.availableSensorIds[0] });
                return text;
            }

            var sensorIds = [...this.availableSensorIds];
            sensorIds = sensorIds.sort(function(a, b) {
                if (a < b) {
                  return -1;
                }
                if (a > b) {
                  return 1;
                }
                return 0;
            });

            if (this.availableSensorIds.length == 2) {
                text = this.$t('report.some-sensors-2', { sensor1: sensorIds[0], sensor2: sensorIds[1] });
                return text;
            }

            if (this.availableSensorIds.length == 3) {
                text = this.$t('report.some-sensors-3', { sensor1: sensorIds[0], sensor2: sensorIds[1], sensor3: sensorIds[2] });
                return text;
            }
        },
        getChartTitle: function() {
            return this.aliasMobile + "<br>(" + this.formatLocalDateTime(this.timestamp.init) + " - " 
                                              + this.formatLocalDateTime(this.timestamp.end) + ")";
        },
        doSendEmail: function() {
						var me = this;
						this.$refs.dlgSendEmail.open((email) => {
								this.$refs.dlgWait.open('email');
								api.getTemperaturesReportPDF(me.idFleet, me.idMobile, me.timestamp.init, me.timestamp.end, me.refreshRate, 
									(reportPDFBytes) => {
										me.getPdfAsBase64Attachment(reportPDFBytes, (reportPDFBase64) => me.sendEmail(email, reportPDFBase64));
									},
									(error) => {
											me.$refs.dlgWait.close();
											me.doShowAlert({ text: error, color: 'error', timeout: 3000 });
									});
						});
        },
        sendEmail: function(email, reportPDFBase64) {
            var timerId = setTimeout(() => {
                //var csvContent = this.exportChartAsCSV();

                var companyName = this.$store.state.wedrive.user.companyName;
                var mobileData = this.$store.state.wedrive.mobileData;
                var index = this.$store.state.wedrive.mobileIndex;
                var initDate = this.formatLocalDateTime(this.timestamp.init);
                var endDate = this.formatLocalDateTime(this.timestamp.end);

                var subject = this.$t('report.email-subject');
                subject = subject.replace('##company_name##', companyName);
                subject = subject.replace('##vehicle_alias##', mobileData[index].aliasMobile[0]);
                subject = subject.replace('##init_date##', initDate);
                subject = subject.replace('##end_date##', endDate);

                var body = this.$t('report.email-body');
                body = body.replace('##company_name##', companyName);
                body = body.replace('##vehicle_alias##', mobileData[index].aliasMobile[0]);
                body = body.replace('##init_date##', initDate);
                body = body.replace('##end_date##', endDate);
                
                this.takeChartScreenshot(document.getElementById('ticketLegend'), document.getElementById('ticketGCHart'), (screenshot) => {
                    var data = { 
                        to: email,
                        body: body,
                        subject: subject,
                        isHtml: false,
                        attachments: [screenshot, reportPDFBase64],
												//attachments: [screenshot, this.getCsvAsBase64Attachment(csvContent)],
                    };

                    cordova.sendEmailOld(data);
                    //cordova.sendEmail(data);
            
                    this.$refs.dlgWait.close();
                });

                clearTimeout(timerId);
            }, 400);
        },        
        exportChartAsCSV() {
            var csvFile = '';

            csvFile += "\"" + this.$t('csv.vehicle') + "\";";
            csvFile += "\"" + this.$t('csv.date') + "\";";
            csvFile += "\"" + this.$t('csv.location') + "\";";
            csvFile += "\"" + this.$t('csv.temp1') + "\";";
            csvFile += "\"" + this.$t('csv.temp2') + "\";";
            csvFile += "\"" + this.$t('csv.temp3') + "\";";
            csvFile += "\"" + this.$t('csv.temp4') + "\"\r\n";

            if (!this.dataRows || this.dataRows.length == 0) {
                return csvFile;
            }
                
            var mobileData = this.$store.state.wedrive.mobileData;
            var index = this.$store.state.wedrive.mobileIndex;

            for (var i = 0; i < this.dataRows.length; i++) {
                if (this.dataRows[i].length == 0) {
                    continue;
                }

                csvFile += "\"" + mobileData[index].aliasMobile[0] + "\";";
                csvFile += "\"" + this.formatLocalDateTime(parseInt(this.dataRows[i].timestamp)) + "\";";
                csvFile += "\"" + this.dataRows[i].fractal[0] + "\";";
                csvFile += "\"" + this.parseTemperature(this.dataRows[i].temperature1) + "\";";
                csvFile += "\"" + this.parseTemperature(this.dataRows[i].temperature2) + "\";";
                csvFile += "\"" + this.parseTemperature(this.dataRows[i].temperature3) + "\";";
                csvFile += "\"" + this.parseTemperature(this.dataRows[i].temperature4) + "\"\r\n";
            }

            return csvFile;
        },
        showSendEmailError: function() {
            this.$refs.dlgSendEmailError.open(this.$t('send-email.error'));
            },
				doPrint: function() {
						if (this.showPrintFeatureNotice) {
							this.$refs.dlgUpgradeApp.open(this.$t('upgrade-app.print-feature-not-available'));
							return;
						}
						/*if (this.isTimestampsHigherThan24h(this.timestamp)) {
							this.doShowAlert({ text: this.$t('print.date-error-2'), color: 'error', timeout: 3000 });
							return;
						}*/
            this.$refs.dlgPrint.open(this.idFleet, this.idMobile, this.sensorIds, this.timestamp, (alert) => {
							this.doShowAlert(alert);
						});
        },
        updateView: function(filterId) {
            if (!filterId) {
								this.prevRangeId = this.rangeId;
                if (this.rangeId == 'current-day') {
									var date = new Date();
									this.timestamp.end = date.getTime();
									date.setHours(0, 0, 0, 0);
									this.timestamp.init = date.getTime();
                } else if (this.rangeId == 'last-12h') {
                    this.calculateLastHoursTimestamps(this.timestamp, 12);
                } else if (this.rangeId == 'last-24h') {
                    this.calculateLastHoursTimestamps(this.timestamp, 24);
                }
                this.doTempRequest(filterId);
                return;
            }
            
            if (filterId == 'sensor') {
                var temperatures = this.filterAvailableSensors(this.availableSensorIds);
                this.chartOptions.colors = this.colors;
                this.chartData = temperatures;
                return;
            }

            if (filterId == 'dates') {
                if (this.rangeId == 'current-day') {
										this.prevRangeId = this.rangeId;
										// eslint-disable-next-line no-redeclare
										var date = new Date();
										this.timestamp.end = date.getTime();
										date.setHours(0, 0, 0, 0);
										this.timestamp.init = date.getTime();
                } else if (this.rangeId == 'last-12h') {
										this.prevRangeId = this.rangeId;
                    this.calculateLastHoursTimestamps(this.timestamp, 12);
								this.prevRangeId = this.rangeId;
                } else if (this.rangeId == 'last-24h') {
										this.prevRangeId = this.rangeId;
                    this.calculateLastHoursTimestamps(this.timestamp, 24);
                } else if (this.rangeId == 'custom-dates') {
										this.$refs.dlgSelectDates.open((timestamp) => {											
												if (this.isTimestampsHigherThan30days(timestamp)) {
													this.doShowAlert({ text: this.$t('print.date-error-3'), color: 'error', timeout: 3000 });
													return;
												}
												this.prevRangeId = this.rangeId;
                        this.timestamp = timestamp;
                        this.doTempRequest(filterId);
                    }, () => {
												this.rangeId = this.prevRangeId;
										});
                    return;
                }

                this.doTempRequest(filterId);
            }
            
            if (filterId == 'period') {
								this.doTempRequest(filterId);
            }
        },
				filterRefresRates(filterId) {
					if (filterId !== 'dates') {
						return;
					}

					if (this.isTimestampsHigherThan9days(this.timestamp)) {
							this.refreshRates = [
									{ text: '30 ' + this.$t('print.minutes'), value: 30 },
									{ text: '60 ' + this.$t('print.minutes'), value: 60 }
							];
							if (this.refreshRates.findIndex(x => x.value == this.refreshRate) == -1) {
								this.refreshRate = 30;
							}
					} else if (this.isTimestampsHigherThan3days(this.timestamp)) {
							this.refreshRates = [
									{ text: '15 ' + this.$t('print.minutes'), value: 15 },
									{ text: '30 ' + this.$t('print.minutes'), value: 30 },
									{ text: '60 ' + this.$t('print.minutes'), value: 60 }
							];
							if (this.refreshRates.findIndex(x => x.value == this.refreshRate) == -1) {
								this.refreshRate = 15;
							}
					} else if (this.isTimestampsHigherThan24h(this.timestamp)) {
							this.refreshRates = [
									{ text: '5 ' + this.$t('print.minutes'), value: 5 },
									{ text: '10 ' + this.$t('print.minutes'), value: 10 },
									{ text: '15 ' + this.$t('print.minutes'), value: 15 },
									{ text: '30 ' + this.$t('print.minutes'), value: 30 },
									{ text: '60 ' + this.$t('print.minutes'), value: 60 }
							];
							if (this.refreshRates.findIndex(x => x.value == this.refreshRate) == -1) {
								this.refreshRate = 10;
							}
					} else {
							this.refreshRates = [
									{ text: '1 ' + this.$t('print.minutes'), value: 1 },
									{ text: '5 ' + this.$t('print.minutes'), value: 5 },
									{ text: '10 ' + this.$t('print.minutes'), value: 10 },
									{ text: '15 ' + this.$t('print.minutes'), value: 15 },
									{ text: '30 ' + this.$t('print.minutes'), value: 30 },
									{ text: '60 ' + this.$t('print.minutes'), value: 60 }
							];
					}
				},
        doTempRequest(filterId) {
						this.filterRefresRates(filterId);

            this.chartTitle = this.getChartTitle();

            this.isLoading = true;

						api.historicTempByPeriod(this.idFleet, this.idMobile, this.timestamp.init, this.timestamp.end, this.refreshRate,          
            (data) => {
                this.isLoading = false;

                this.parseTemperatures(data);                
                this.checkAvailableSensors();

                this.sensorIds = this.sensors;

                var temperatures = this.calculateTemperatures();

                if (temperatures.length == 0) {
                    this.showNoDataNotice = true;
                    return;
                }

                this.showNoDataNotice = false;

                this.chartOptions.colors = this.colors;
                this.chartData = temperatures;
                
                this.$store.commit('wedrive/setNumAttempts', 0);
            },
            (error) => {
                this.isLoading = false;
                this.$store.commit('wedrive/increaseNumAttempts');
                this.doShowAlert({ text: error, color: 'error', timeout: 3000 });
            });
        },
        doRefresh: function() {
            this.isLoading = true;
            
            this.updateMobileData(
            () => {
                this.isLoading = false;
                this.updateView();
            }, 
            (error) => {
                this.isLoading = false;
                this.doShowAlert({ text: error, color: 'error', timeout: 3000 });
            });
        }
    },
    watch: {
        sensorIds: function (e) {
            if (e.length > 1) {
                this.sensors.forEach((item) => item.disabled = false);
            } else {
                this.sensors.forEach((item) => {
                    if (this.availableSensorIds.length == 1 && this.availableSensorIds.includes(item.value)) {
                        item.disabled = true;
                    }
                });
            }
        },
        // eslint-disable-next-line no-unused-vars
        $route(to, from) {
            this.idFleet = parseInt(to.params.idFleet);
            this.idMobile = parseInt(to.params.idMobile);
            this.aliasMobile = to.params.aliasMobile;
            this.$store.commit('wedrive/setNavTitle', this.$t('report.title'));
            this.updateView();
        },
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.idFleet = parseInt(to.params.idFleet);
            vm.idMobile = parseInt(to.params.idMobile);
            vm.aliasMobile = to.params.aliasMobile;
            vm.$store.commit('wedrive/setNavTitle', vm.$t('report.title'));
            vm.$store.commit('wedrive/setShowLastUpdate', true);
            vm.updateView();
        });
    }
};
</script>